// 1 month before next year's renewal. Email only. MARKETING (PECR unsubscribe).

import type { EmailData } from "../../types";
import { anniversary, longDate } from "../../format";
import { b, body, call, esc, p } from "../../layouts/chrome";
import { callCta, plainEmailHtml } from "../../layouts/plain";
import { brand } from "../brand";

export const subject = (_data: EmailData) =>
  `Your business insurance is due for renewal soon — let ${brand.name} quote`;

export const html = (data: EmailData) =>
  plainEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    heading: "Time to review your business insurance",
    cta: callCta(brand.callNumber),
    unsubscribeUrl: data.unsubscribeUrl,
    bodyHtml: body(
      p(
        `It's coming up to a year since ${b(`'${esc(data.companyName)}'`)} was insured with us — which means your current policy is likely due for renewal around ${b(longDate(anniversary(data.renewalDate)))}.`,
      ),
      p(
        `We'd love to win your business back. Let ${brand.name} compare quotes from our panel of leading insurers, and we'll add a ${b("£25 Amazon voucher")} when your new policy starts.`,
      ),
      p(`Call our UK-based team on ${call(brand)} for a fast, no-obligation quote.`),
      p(
        "£25 Amazon voucher: one per business, issued after your new policy has been active for 30 days. Ask our team for full terms.",
      ),
    ),
  });
